import { useTranslation } from '../../hooks/useTranslation'
import type { Locale } from '../../../locales/types'
import { LOCALES } from '../../../locales/types'

export function LanguageSwitcher() {
  const { locale, changeLocale, isLoading } = useTranslation()

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    changeLocale(e.target.value as Locale)
  }

  return (
    <select
      value={locale}
      onChange={handleChange}
      disabled={isLoading}
      className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-brand-500 sm:text-sm sm:leading-6"
      aria-label="Select language"
    >
      {(Object.entries(LOCALES) as [Locale, string][]).map(([code, name]) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </select>
  )
}
